import { AxiosResponse } from 'axios'
import { httpClient } from 'shared/api/http-client'
import { LOGIN_API } from 'modules/authentication/api/constants'
import {
  CommunityInterface,
  CreateCommunityInterface,
} from 'modules/community/types/community-interface'
import { PostInterface } from 'modules/community/types/post-interface'

export function updateCommunitySettings(
  communityPath: string,
  data: CreateCommunityInterface,
): Promise<AxiosResponse<CommunityInterface, unknown, {}>> {
  return httpClient.patch<CommunityInterface>(
    `/api/community/community/${communityPath}/settings`,
    data,
  )
}

export function registerCommunity(
  email: string,
  communityUrl: string,
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(`/api/register`, {
    email,
    communityUrl,
  })
}

export function login(
  email: string,
  password: string,
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(LOGIN_API, {
    email,
    password,
  })
}

export function likePost(
  postId: PostInterface['id'],
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.post(`/api/community/post/${postId}/like`)
}

export function unlikePost(
  postId: PostInterface['id'],
): Promise<AxiosResponse<unknown, unknown, {}>> {
  return httpClient.delete(`/api/community/post/${postId}/remove-like`)
}
